"use strict";
/**
 *
 * Form
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const plumb_1 = require("@domonda/plumb");
const fast_equals_1 = require("fast-equals");
// form
const Form_1 = require("./Form");
const createFormField_1 = require("./createFormField");
const FormTag_1 = require("./FormTag");
const DEFAULT_AUTO_SUBMIT_DELAY = 300;
function createForm(defaultValues = {}, initialConfig = {}) {
    const configRef = new Form_1.FormConfigRef(initialConfig, handleSubmit);
    const plumb = plumb_1.createPlumb({
        defaultValues,
        values: defaultValues,
        fields: {},
        submitting: false,
        submitError: null,
        disabled: false,
        readOnly: false,
    });
    function applyConfig(usingConfig) {
        const { autoSubmit, autoSubmitDelay = DEFAULT_AUTO_SUBMIT_DELAY } = usingConfig;
        if (autoSubmit) {
            let currState = plumb.state;
            let currTimeout;
            plumb.subscribe((nextState, tag) => {
                (() => {
                    if (tag !== FormTag_1.FormTag.FIELD_VALUE_CHANGE && tag !== FormTag_1.FormTag.VALUES_CHANGE) {
                        return;
                    }
                    if (fast_equals_1.deepEqual(currState.values, nextState.values) ||
                        fast_equals_1.deepEqual(nextState.defaultValues, nextState.values)) {
                        return;
                    }
                    if (autoSubmitDelay > 0) {
                        if (currTimeout) {
                            clearTimeout(currTimeout);
                        }
                        currTimeout = setTimeout(() => {
                            submit();
                        }, autoSubmitDelay);
                    }
                    else {
                        submit();
                    }
                })();
                currState = nextState;
            });
        }
    }
    applyConfig(configRef.current);
    const form = {
        plumb,
        get state() {
            return plumb.state;
        },
        get values() {
            return plumb.state.values;
        },
        configRef,
        submit,
        reset: () => {
            plumb.next(Object.assign(Object.assign({}, plumb.state), { values: plumb.state.defaultValues, submitting: false, submitError: null }), FormTag_1.FormTag.VALUES_RESET);
        },
        resetSubmitError: () => {
            plumb.next(Object.assign(Object.assign({}, plumb.state), { submitting: false, submitError: null }), FormTag_1.FormTag.SUBMIT_ERROR_RESET);
        },
        makeFormField: (path, config) => createFormField_1.createFormField(plumb, path, config),
    };
    function handleSubmit(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const { resetOnSuccessfulSubmit, resetOnFailedSubmit, onSubmit, disableOnSubmit, } = configRef.current;
            if (onSubmit) {
                if (event) {
                    event.preventDefault();
                }
                plumb.next(Object.assign(Object.assign({}, plumb.state), { submitting: true, submitError: null, disabled: disableOnSubmit ? true : plumb.state.disabled }), FormTag_1.FormTag.SUBMIT);
                const { fields } = plumb.state;
                const validityMessages = Object.keys(fields).reduce((acc, key) => {
                    const field = fields[key];
                    if (!field) {
                        return acc;
                    }
                    return [...acc, field.validityMessage];
                }, []);
                if (validityMessages.some((validityMessages) => validityMessages != null)) {
                    plumb.next(Object.assign(Object.assign({}, plumb.state), { submitting: false, disabled: false }), FormTag_1.FormTag.SUBMIT);
                    return;
                }
                // if all validations passed, continue with the submit
                try {
                    yield onSubmit(plumb.state.values, form);
                    if (!plumb.disposed) {
                        plumb.next(Object.assign(Object.assign({}, plumb.state), { submitting: false, disabled: disableOnSubmit ? false : plumb.state.disabled, values: resetOnSuccessfulSubmit ? plumb.state.defaultValues : plumb.state.values }), resetOnSuccessfulSubmit ? FormTag_1.FormTag.SUBMIT_WITH_DEFAULT_VALUES_CHANGE : FormTag_1.FormTag.SUBMIT);
                    }
                }
                catch (error) {
                    if (!plumb.disposed) {
                        plumb.next(Object.assign(Object.assign({}, plumb.state), { submitting: false, submitError: error, disabled: disableOnSubmit ? false : plumb.state.disabled, values: resetOnFailedSubmit ? plumb.state.defaultValues : plumb.state.values }), resetOnFailedSubmit ? FormTag_1.FormTag.SUBMIT_WITH_DEFAULT_VALUES_CHANGE : FormTag_1.FormTag.SUBMIT);
                    }
                }
            }
        });
    }
    function submit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!configRef.current.el) {
                yield handleSubmit(null);
            }
            else if (configRef.current.el.reportValidity()) {
                configRef.current.el.dispatchEvent(new Event('submit', { cancelable: true }));
            }
        });
    }
    return [form, () => plumb.dispose()];
}
exports.createForm = createForm;
